import { Interpolation, Theme, css } from '@emotion/react'

export const form: Interpolation<Theme> = (theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing(3)};

  margin-top: ${theme.spacing(6)};
  width: 100%;
`

export const formActions: Interpolation<Theme> = (theme) => css`
  width: 100%;
  display: flex;
  column-gap: ${theme.spacing(3)};
`

export const columnsWrapper: Interpolation<Theme> = (theme) => css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${theme.spacing(3)};
`

export const labelWrapper: Interpolation<Theme> = (theme) => css`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyThree};
  margin-bottom: ${theme.spacing(1.25)};
`

export const textarea: Interpolation<Theme> = css`
  resize: vertical;
`
